<script>
  import { createEventDispatcher } from 'svelte';
  import ReadMore from './ReadMore/ReadMore.svelte';
  const dispatch = createEventDispatcher();
  export let note;
  export let time;
  export let value = '';
  const onClick = (e) => {
    value = e.target.value;
    dispatch('onClick', e);
  };
</script>

<div class="task-reminder mb-2">
  <div class="d-flex flex-row">
    <div class="task-message rounded p-2 w-100 d-flex align-items-center">
      <ReadMore
        time={time}
        label={note}
      />
    </div>
    <div class="task-trash text-right ms-1">
      <button
        class="border-0 bg-transparent"
        on:click={onClick}
      >
        <img
          alt=""
          src="/images/remove.svg"
        />
      </button>
    </div>
  </div>
</div>

<style lang="scss">
  .task-reminder {
    .task-message {
      background: rgba($input-border-color, 0.4);
    }
    .task-trash {
      flex: 0 0 35px;
      max-width: 28px;
      text-align: right;
      font-size: 15px;
      margin-top: 2px;
    }

    .task-trash {
      img {
        width: 22px;
        height: 22px;
      }
    }
  }
</style>
